const actionTypes = {
  UPDATE_USER_PERSONAL_INFO: "seneca/user/UPDATE_USER_PERSONAL_INFO",
  SET_USER: "seneca/user/SET_USER"
};

export default actionTypes;
